import React from 'react';
import './Header.css';
import MetaTags from './MetaTags';

const Header = () => {
  return (
    <>
      <MetaTags />
      <header className="header">
        <div className="header-content">
          <h1>Little Lemon</h1>
          <p>Mediterranean Restaurant</p>
          <div className="header-meta">
            <span className="header-location">📍 Chicago, Illinois</span>
            <span className="header-hours">🕒 Open Today: 11:00 AM - 10:00 PM</span>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;